import { useAuth, type AccountTier } from '@/contexts/AuthContext';

const ORDER: Record<AccountTier, number> = { guest: 0, quick: 1, full: 2 };

/**
 * Returns the current account tier and a helper to check minimum tier.
 */
export function useAccountTier() {
  const { tier, user, loading, isAnonymous } = useAuth();
  return {
    tier,
    user,
    loading,
    isAnonymous,
    isGuest: tier === 'guest',
    isQuick: tier === 'quick',
    isFull: tier === 'full',
    /** true if current tier meets or exceeds the required tier */
    hasTier: (required: AccountTier) => ORDER[tier] >= ORDER[required],
  };
}

export type { AccountTier };